import { Component, OnInit } from '@angular/core';
import { RootService } from '../../service/root.service';
import { FAuth } from '../shared/fAuth';

import {TranslateService} from '@ngx-translate/core';
import {  Router } from '@angular/router';
declare var lbd:any;
@Component({

    selector: 'auth-signup',
    templateUrl: './auth-signup.component.html',
    styleUrls: ['./auth-signup.component.scss']
})
export class AuthSignupComponent implements OnInit {
    fAuth = new FAuth();
    user;
    constructor(public rootService: RootService,private translate: TranslateService,private router: Router) { 
        this.user=null;
    }
    submittingForm: boolean = false;

    ngOnInit() { 
        lbd.checkFullPageBackgroundImage();
            
            setTimeout(function(){
                // after 1000 ms we add the class animated to the login/register card
                $('.card').removeClass('card-hidden');
            }, 200)
    }
    onSubmit(form){
         if (this.submittingForm) {
            return;
        }
        this.submittingForm = true;
       this.rootService.signup(this.fAuth).subscribe(item => {
           this.rootService.toast.showSuccess(this.translate.instant('auth.common.registerM',{item:this.translate.instant('title')}));
           this.router.navigate(['admin/dashboard']);
            this.submittingForm = false;
        }, err => {
            this.rootService.toast.showErrorCode(err.code);
            this.submittingForm = false;
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/auth/auth-signup/auth-signup.component.ts